import { gql } from '@apollo/client';

const ENDPOINT = {
    GET_HPP_REQUEST: gql`
        query getHPP($prospectUuid: String!) {
            hppRequest(prospectUuid: $prospectUuid) {
                ACCOUNT
                AMOUNT
                AUTO_SETTLE_FLAG
                BILLING_CO
                BILLING_CODE
                CARD_PAYMENT_BUTTON
                CARD_STORAGE_ENABLE
                COMMENT1
                COMMENT2
                CURRENCY
                CUST_NUM
                DCC_ENABLE
                HPP_FRAUDFILTER_MODE
                HPP_LANG
                HPP_SELECT_STORED_CARD
                HPP_VERSION
                MERCHANT_ID
                OFFER_SAVE_CARD
                ORDER_ID
                PAYER_EXIST
                PAYER_REF
                PMT_REF
                PROD_ID
                RETURN_TSS
                SHA1HASH
                SHIPPING_CO
                SHIPPING_CODE
                TIMESTAMP
                VALIDATE_CARD_ONLY
                VAR_REF
                MERCHANT_RESPONSE_URL
                HPP_ADDRESS_MATCH_INDICATOR
                HPP_BILLING_CITY
                HPP_BILLING_COUNTRY
                HPP_BILLING_POSTALCODE
                HPP_BILLING_STATE
                HPP_BILLING_STREET1
                HPP_BILLING_STREET2
                HPP_BILLING_STREET3
                HPP_CHALLENGE_REQUEST_INDICATOR
                HPP_CUSTOMER_EMAIL
                HPP_CUSTOMER_PHONENUMBER_MOBILE
                HPP_SHIPPING_CITY
                HPP_SHIPPING_COUNTRY
                HPP_SHIPPING_POSTALCODE
                HPP_SHIPPING_STATE
                HPP_SHIPPING_STREET1
                HPP_SHIPPING_STREET2
                HPP_SHIPPING_STREET3
            }
        }
    `,
    VALIDATE_PAYMENT: gql`
        mutation validatePayment($prospectUuid: String!, $HppResponse: HppResponse!) {
            validatePayment(prospectUuid: $prospectUuid, HppResponse: $HppResponse)
        }
    `,

    GET_OPERATOR: gql`
        query getOperator($msisdn: String!) {
            operator(msisdn: $msisdn) {
                isPortInProgressAlready
                network {
                    id
                    networkName
                }
            }
        }
    `,
    GET_PORTING_DATE_TIME: gql`
        query getPortingTime($brand: String!, $channel: String!) {
            portingTime(brand: $brand, channel: $channel) {
                portingHours {
                    date
                    startTime
                    endTime
                }
            }
        }
    `,
    GET_OTP: gql`
        query getOTP($msisdn: String!) {
            OTP(msisdn: $msisdn) {
                otpUuid
            }
        }
    `,
    VALIDATE_OTP: gql`
        mutation validateOTP($otpUuid: String!, $otp: String!) {
            validateOTP(otpUuid: $otpUuid, otp: $otp)
        }
    `,
    GET_PLANS: gql`
        query getPlans($planIds: [String!]) {
            plans(planIds: $planIds) {
                planId
                price
                attributes {
                    name
                    value
                    sortOrder
                }
                catalogAddonBundleCode
                name
            }
        }
    `,
    GET_DEVICE_LIST: gql`
        query getDeviceList($catalogOfferCode: String!) {
            deviceList(catalogOfferCode: $catalogOfferCode) {
                id
                name
                displayName
                model
                manufacturer
                url
                sortingOrder
                imageName
                price
                fromPrice
                details {
                    description
                    specifications
                    features
                    prices {
                        mobileOrderType
                        price
                    }
                }
                flash {
                    id
                    title
                    description
                    shortDescription
                }
                variants {
                    catalogHandsetCode
                    name
                    colour
                    sku
                    inStock
                    stockStatus
                    carouselImages {
                        path
                        description
                    }
                    image {
                        path
                        description
                    }
                }
                availability {
                    status
                    availableDate
                }
            }
        }
    `,
    GET_DEVICE_DETAILS: gql`
        query getDeviceDetails($deviceId: String!) {
            deviceDetails(deviceId: $deviceId) {
                id
                name
                displayName
                model
                manufacturer
                url
                sortingOrder
                imageName
                price
                fromPrice
                details {
                    description
                    prices {
                        mobileOrderType
                        price
                    }
                    specifications
                    features
                }
                variants {
                    catalogHandsetCode
                    name
                    colour
                    sku
                    inStock
                    stockStatus
                    carouselImages {
                        path
                        description
                    }
                }
                flash {
                    id
                    title
                    description
                    shortDescription
                }
                availability {
                    status
                    availableDate
                }
            }
        }
    `,
    CREATE_PROSPECT: gql`
        mutation createProspect($brand: String!, $channelType: String!, $offerType: String!) {
            prospect(
                prospectInput: { brand: $brand, channelType: $channelType, offerType: $offerType }
            ) {
                prospectUuid
                orderReference
            }
        }
    `,
    ADD_OFFER: gql`
        mutation addOffer($prospectUuid: String!, $offerName: String!) {
            addOffer(prospectUuid: $prospectUuid, offerName: $offerName) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
            }
        }
    `,
    ADD_PLAN: gql`
        mutation addPlan($prospectUuid: String!, $cartOfferId: Int!, $planId: String!) {
            addPlan(prospectUuid: $prospectUuid, cartOfferId: $cartOfferId, planId: $planId) {
                orderReference
                numberOfProducts
                nddPreference
                offerId
                topUpAmount
                device {
                    fromPrice
                    id
                    manufacturer
                    model
                    name
                    price
                    sortingOrder
                    url
                    variants {
                        colour
                        inStock
                        name
                        sku
                        stockStatus
                    }
                }
                plan {
                    planId
                    catalogAddonBundleCode
                    addonId
                    price
                    catalogAddonBundleCode
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
            }
        }
    `,
    ADD_HANDSET: gql`
        mutation addHandset(
            $prospectUuid: String!
            $cartOfferId: Int!
            $deviceId: Int!
            $catalogHandsetCode: String!
        ) {
            addHandset(
                prospectUuid: $prospectUuid
                cartOfferId: $cartOfferId
                handsetInput: { deviceId: $deviceId, catalogHandsetCode: $catalogHandsetCode }
            ) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
            }
        }
    `,
    GET_CART_DETAILS: gql`
        query getCart($prospectUuid: String!) {
            cartDetails(prospectUuid: $prospectUuid) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
                availableTopUp
            }
        }
    `,
    GET_QUADPLAY_CART_DETAILS: gql`
    query getCart($reference: String!, $cartType: CartType, $token: String) {
      getCart(reference: $reference,
        cartType: $cartType,
        token: $token) {
            uuid
            offers {
                id
              }
        }
      }
    `,
    ADD_TOPUP: gql`
        mutation addTopupValue($prospectUuid: String!, $cartOfferId: Int!, $topUpAmount: Int!) {
            topupAmount(
                prospectUuid: $prospectUuid
                cartOfferId: $cartOfferId
                topUpAmount: $topUpAmount
            ) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
                availableTopUp
            }
        }
    `,
    GET_ADDRESSLIST: gql`
        query getAddress($eirCode: String!) {
            addressList(eirCode: $eirCode) {
                addresses {
                    addressLine1
                    addressLine2
                    addressLine3
                    town
                    county
                    eircode
                }
            }
        }
    `,
    GET_AREACODES: gql`
    query getAreacodes {
        areaCodes {
            AREA_CODE
        }
    }
`,
    UPDATE_NDD: gql`
        mutation nddPreference(
            $prospectUuid: String!
            $cartOfferId: Int!
            $nddPreference: String!
        ) {
            nddPreference(
                prospectUuid: $prospectUuid
                cartOfferId: $cartOfferId
                nddPreference: $nddPreference
            ) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
            }
        }
    `,

    UPDATE_CUSTOMERDETAILS: gql`
        mutation updateCustomerDetail(
            $prospectUuid: String!
            $hasAgreedTermsAndConditions: Boolean!
            $customerDetailInput: CustomerDetailInput!
        ) {
            updateCustomerDetail(
                prospectUuid: $prospectUuid
                hasAgreedTermsAndConditions: $hasAgreedTermsAndConditions
                customerDetailInput: $customerDetailInput
            ) {
                isAnonymous
                owner {
                    email
                    mobileNumber
                    person {
                        firstName
                        lastName
                        birthDate
                    }
                }
                deliveryAddress {
                    addressLine1
                    addressLine2
                    addressLine3
                    county
                    town
                    eircode
                }

                billingAddress {
                    addressLine1
                    addressLine2
                    addressLine3
                    county
                    town
                    eircode
                }
                securityQuestion {
                    questionCode
                    response
                }
                contactPermission {
                    allowThirdParty
                    permissionGroupResponse {
                        name
                        permissionGroup
                        permissions {
                            name
                            enabled
                            permission
                        }
                    }
                }
            }
        }
    `,

    GET_CUSTOMERDETAILS: gql`
        query customerDetails($prospectUuid: String!) {
            customerDetails(prospectUuid: $prospectUuid) {
                isAnonymous
                owner {
                    email
                    mobileNumber
                    person {
                        firstName
                        lastName
                        birthDate
                    }
                }
                deliveryAddress {
                    addressLine1
                    addressLine2
                    addressLine3
                    county
                    town
                    eircode
                }

                billingAddress {
                    addressLine1
                    addressLine2
                    addressLine3
                    county
                    town
                    eircode
                }
                securityQuestion {
                    questionCode
                    response
                }
                contactPermission {
                    allowThirdParty
                    permissionGroupResponse {
                        name
                        permissionGroup
                        permissions {
                            name
                            enabled
                            permission
                        }
                    }
                }
            }
        }
    `,
    GET_SECURITYQUESTIONS: gql`
        query securityQuestions {
            securityQuestions {
                code
                question
            }
        }
    `,

    GET_DISCOUNT: gql`
        query getDiscount($offerName: String!) {
            discounts(offerName: $offerName) {
                catalogDiscountCode
                description
                value
                discountType
            }
        }
    `,
    ADD_DISCOUNT: gql`
        mutation addDiscount($prospectUuid: String!, $cartOfferId: Int!, $catalogDiscountCode: String!) {
            addDiscount(
                prospectUuid: $prospectUuid
                cartOfferId: $cartOfferId
                catalogDiscountCode: $catalogDiscountCode
            ) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
                availableTopUp
            }
        }
    `,
    REMOVE_DISCOUNT: gql`
        mutation removeDiscount($prospectUuid: String!, $cartOfferId: Int!) {
            removeDiscount(prospectUuid: $prospectUuid, cartOfferId: $cartOfferId) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
                availableTopUp
            }
        }
    `,

    ADD_PORT: gql`
        mutation addPort(
            $prospectUuid: String!
            $cartOfferId: Int!
            $otherNetworkAccountNumber: String
            $otherNetworkId: Int
            $otherNetworkName: String
            $phoneNumber: String
            $portStartDateTime: String
            $type: String
        ) {
            addPort(
                prospectUuid: $prospectUuid
                cartOfferId: $cartOfferId
                portInInput: {
                    otherNetworkAccountNumber: $otherNetworkAccountNumber
                    otherNetworkId: $otherNetworkId
                    otherNetworkName: $otherNetworkName
                    phoneNumber: $phoneNumber
                    portStartDateTime: $portStartDateTime
                    type: $type
                }
            ) {
                orderReference
            }
        }
    `,
    REMOVE_PORT: gql`
        mutation removePort($prospectUuid: String!, $cartOfferId: Int!) {
            removePort(prospectUuid: $prospectUuid, cartOfferId: $cartOfferId) {
                orderReference
                plan {
                    planId
                    price
                    catalogAddonBundleCode
                    addonId
                    attributes {
                        name
                        value
                        sortOrder
                    }
                }
                numberOfProducts
                device {
                    id
                    name
                    model
                    manufacturer
                    variants {
                        catalogHandsetCode
                        name
                        colour
                        sku
                        inStock
                        stockStatus
                        carouselImages {
                            path
                            description
                        }
                        image {
                            path
                            description
                        }
                    }
                    handsetId
                    url
                    sortingOrder
                    imageName
                    price
                    fromPrice
                    details {
                        description
                        prices {
                            mobileOrderType
                            price
                        }
                        specifications
                        features
                    }
                    flash {
                        id
                        title
                        description
                        shortDescription
                    }
                    availability {
                        status
                        availableDate
                    }
                }
                port {
                    otherNetworkAccountNumber
                    otherNetworkId
                    otherNetworkName
                    phoneNumber
                    portStartDateTime
                    type
                }
                discount {
                    catalogDiscountCode
                    description
                    value
                    discountType
                }
                offerId
                nddPreference
                topUpAmount
                availableTopUp
            }
        }
    `,
    GET_DEVICE_DETAILS_BYNAME: gql`
        query getDeviceDetailsByName($deviceName: String!) {
            deviceDetailsByName(deviceName: $deviceName) {
                id
                name
                displayName
                model
                manufacturer
                url
                sortingOrder
                imageName
                price
                fromPrice
                details {
                    description
                    prices {
                        mobileOrderType
                        price
                    }
                    specifications
                    features
                }
                variants {
                    catalogHandsetCode
                    name
                    colour
                    sku
                    inStock
                    stockStatus
                    carouselImages {
                        path
                        description
                    }
                }
                flash {
                    id
                    title
                    description
                    shortDescription
                }
                availability {
                    status
                    availableDate
                }
            }
        }
    `,
    DECREASE_STOCK: gql`
        mutation decreaseStock($catalogHandsetCode: String!) {
            decreaseStock(catalogHandsetCode: $catalogHandsetCode) {
                name
                model
            }
        }
    `,
    GET_PREQUAL_BY_PHONENUMBER: gql`
        query prequalByPhone(
            $phoneNumber: PrequalPhoneNumber
            $channel: String!
        ) {
            prequalByPhone(
                prequalPhoneNumber: $phoneNumber
                channel: $channel
            ) {
                prequalid
                channel
                eircode
                phone
                county
                fullAddress
                maxHSI
                maxFTCHSI
                maxNBI
                maxNGB
                maxDSL
                ifth
                iftc
                inbi
                ingb
                idsl
                inga
                error
                itv
                customerType
            }
        }
    `,
    GET_PREQUAL_BY_EIRCODE: gql`
        query prequalByEircode($prequalAddress: PrequalAddress $channel: String!) {
            prequalByEircode( prequalAddress: $prequalAddress channel: $channel ) {
                prequalid
                channel
                eircode
                phone
                county
                error
                fullAddress
                maxHSI
                maxFTCHSI
                maxNBI
                maxNGB
                maxDSL
                ifth
                iftc
                inbi
                ingb
                idsl
                inga
                error
                itv
                customerType
            }
        }
    `,
};
export default ENDPOINT;
